<div class="btn-group-toggle">
  <label class="btn toggle-button no-outline" [ngClass]="{ active: value }">
    <i class="{{ value ? 'far fa-check-square' : 'far fa-square' }}"></i>
    {{ label }}
  </label>
</div>
